import { useMemo } from 'react';

import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { ConfigPedidoAutomaticaProcessamentoProps, StatusGeracaoConfig } from 'pages/compra/configuracao-pedido/types';

function getStatusColor(idStatus: number): 'error' | 'info' | 'success' | 'warning' {
    if (idStatus === StatusGeracaoConfig.FINALIZADO_COM_FALHA) return 'error';
    if (idStatus === StatusGeracaoConfig.FINALIZADO_COM_SUCESSO) return 'success';
    if (idStatus === StatusGeracaoConfig.AGUARDANDO) return 'warning';

    return 'info';
}

export function useQueryStatusGeracao() {
    const { id } = useParams();
    const requestListagem = useRequestListagem();

    const { data, refetch } = useQuery<ConfigPedidoAutomaticaProcessamentoProps>({
        queryKey: ['statusGeracao', id],
        queryFn: () =>
            requestListagem({ url: `gestao/configpedidoautomaticaprocessamento/configpedido/${id}` }).then((res) => res.data),
        refetchInterval: (data) => {
            if (data) {
                const { idConfigPedidoAutomaticaProcessamentoStatus } = data.configPedidoAutomaticaProcessamentoStatus;

                if ([StatusGeracaoConfig.AGUARDANDO, StatusGeracaoConfig.PROCESSANDO].includes(idConfigPedidoAutomaticaProcessamentoStatus)) {
                    return 2000;
                }
            }

            return false;
        },
    });

    const statusGeracao = useMemo(() => {
        if (!data?.configPedidoAutomaticaProcessamentoStatus) return null;

        const { idConfigPedidoAutomaticaProcessamentoStatus: idStatusGeracao, dsConfigPedidoAutomaticaProcessamentoStatus: dsStatusGeracao } =
            data.configPedidoAutomaticaProcessamentoStatus;

        return {
            idStatusGeracao,
            dsStatusGeracao,
            colorStatusGeracao: getStatusColor(idStatusGeracao),
        };
    }, [data]);

    return { statusGeracao, refetch };
}
